import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Form as FinalForm, Field } from 'react-final-form';
import { Form } from 'semantic-ui-react';

import SubmittingSection from 'components/SubmissionSection';
// Actions
// @ts-ignore
import { requestCreateWorkType } from '../../../../../../../../services/workTypes/actions';

// Components
import ErrorAlert from '../../../../../../../../components/ErrorAlert';
// @ts-ignore
import EntityTypeOptions from '../../../../../../../../components/EntityTypeOptions';

// Form
import {
    normalizers,
    validators,
    RenderField,
    RenderDropdown
    // @ts-ignore
} from '../../../../../../../../forms';

// Selectors
// @ts-ignore
import { selectInitialValues } from './selectors';

// Normalizers
const { toNull, toNumber } = normalizers;

// Validators
const { composeValidators, isBoolean, isRequired, isPositiveNumber } =
    validators;

// Constants
const NAMESPACE = 'WORK_TYPE_CREATE';

interface Props {
    error?: string;
    onClose: Function;
    requestCreateWorkType: Function;
}

class WorkTypeForm extends React.PureComponent<Props> {
    handleSubmit = (values: Record<string, any>): void => {
        this.props.requestCreateWorkType(values);
    };

    render(): React.ReactElement {
        const { onClose } = this.props;

        return (
            <FinalForm
                onSubmit={this.handleSubmit}
                subscription={{}}
                render={(props: any): React.ReactElement => {
                    const { handleSubmit } = props;

                    return (
                        <Form autoComplete="off" onSubmit={handleSubmit}>
                            <Field
                                name="name"
                                component={RenderField as any}
                                label="Name"
                                type="text"
                                placeholder="Enter name"
                                parse={toNull}
                                validate={isRequired}
                            />
                            <EntityTypeOptions>
                                {(options: any): React.ReactElement => (
                                    <Field
                                        name="entityTypeId"
                                        label="Area Type"
                                        placeholder="Add area type"
                                        validate={isRequired}
                                        parse={toNull}
                                        fluid
                                        component={RenderDropdown as any}
                                        options={options}
                                        search
                                        selection
                                        closeOnChange
                                        upward={false}
                                        clearable
                                        selectOnBlur={false}
                                    />
                                )}
                            </EntityTypeOptions>
                            <Field
                                name="isPieceRate"
                                component={RenderDropdown as any}
                                label="Task Type"
                                placeholder="Add task type"
                                options={[
                                    {
                                        key: 1,
                                        text: 'Hourly',
                                        value: false
                                    },
                                    {
                                        key: 2,
                                        text: 'Piece Rate',
                                        value: true
                                    }
                                ]}
                                validate={isBoolean}
                                fluid
                                selection
                                clearable
                                selectOnBlur={false}
                            />
                            <Field
                                name="payrollCode"
                                component={RenderField as any}
                                label="Payroll Code"
                                type="number"
                                placeholder="Enter payroll code"
                                parse={toNumber}
                                validate={composeValidators(
                                    isRequired,
                                    isPositiveNumber
                                )}
                            />
                            <ErrorAlert namespace={NAMESPACE} />
                            <SubmittingSection
                                submittingButtonParam={{
                                    namespace: NAMESPACE
                                }}
                                normalCancelButtonParam={{
                                    onClose: (): void => {
                                        onClose();
                                    }
                                }}
                            />
                        </Form>
                    );
                }}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    initialValues: selectInitialValues
});

export default connect(mapStateToProps, { requestCreateWorkType })(
    WorkTypeForm
);
